/**
 * Categorical data-series colours. These values identify series and must not
 * be replaced with semantic warning or danger variables.
 */
export const CHART_SERIES_COLOURS = {
  bluebirdAnnual: '#f59e0b',
  completedOnTime: '#d97706',
  dashboardFallback: ['#4f7f22', '#008c95', '#9956bd', '#d97706']
} as const;
